import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import railsContext from 'lib/selectors/rails-context'
import I18n from 'lib/i18n'
import ReactHtmlParser from 'react-html-parser'

const Translate = ({ review, translateReview, translating }) => {
  const { i18nLocale } = useSelector(railsContext)
  const { id, locale, defaultLocale } = review

  const handleTranslate = reviewId => {
    translateReview(reviewId, locale === i18nLocale ? defaultLocale : i18nLocale)
  }

  if (defaultLocale === i18nLocale) {
    return null
  }

  return (
    <div className='translate-container'>
      <span className='translate-text'>
        <span
          className={`translate-button${locale === i18nLocale ? ' to-translate' : ''}`}
          onClick={() => handleTranslate(id)}
          style={{ cursor: translating ? 'wait' : 'pointer' }}
        >
          {locale !== i18nLocale ? (
            <span className='request-translate'>{I18n.t('pages.reviews.see_translation')}</span>
          ) : (
            <span>{ReactHtmlParser(I18n.t('pages.reviews.see_original_translated'))}</span>
          )}
        </span>
      </span>
    </div>
  )
}

export default Translate

Translate.propTypes = {
  review: PropTypes.object,
  translateReview: PropTypes.func,
  translating: PropTypes.bool
}
